// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1jsG9","badges":"styles_badges__3yFVx"};